const store = {}

export default store



// WEBPACK FOOTER //
// ./src/assets/js/store.js